
import * as Cesium from 'cesium';
import './MultiGroundObjectCard.scss';
import { AltitudeSvg, GroundStationSvg, GroundTargetSvg, LatLongSvg, NewAltitudeSvg } from './svgs/Svgs';
import { getBandKey, truncateAltitude, truncateNumber } from '../../utils/commonFunctions';
import CustomToolTip from './CustomToolTip';
import { OverlayTrigger } from 'react-bootstrap';
import GroundStationCard from './GroundStationCard';
import { useState } from 'react';
interface Props {
    assets: {
        stations: any[],
        targets: any[],
        latitude: number,
        longitude: number,
    } | null;
    viewer: Cesium.Viewer | null;
}

const MultiGroundObjectCard = ({ assets, viewer }: Props) => {
    const [hoverdStation, setHoverdStation] = useState<any>(null);

    if (viewer && assets) {
        const width = 400
        const { latitude, longitude, stations, targets } = assets
        const showDevider = stations.length > 0 && targets.length > 0
        let cartographic = Cesium.Cartographic.fromDegrees(longitude, latitude);
        let cartesianPosition = Cesium.Cartographic.toCartesian(cartographic);
        const popupPosition = Cesium.SceneTransforms.wgs84ToWindowCoordinates(
            viewer.scene,
            cartesianPosition
        );
        let outside_window_x = (popupPosition.x + (width + 10)) > window.innerWidth;
        let top = `${popupPosition.y}px`;
        let left = outside_window_x ? `${popupPosition.x - (width + 5)}px` : `${popupPosition.x + 5}px`;

        return (
            <div className={`popup__modal__container`}
                style={{
                    width: `${width}px`,
                    display: assets ? 'flex' : 'none',
                    cursor: 'default',
                    left: left,
                    top: top,
                    transition: 'all 1s ease',
                    zIndex: 99,
                }}
            >
                {stations && stations.length > 0 &&
                    <OverlayTrigger
                        overlay={
                            <div className={`popup-modal modal__overlay expand`}>
                                <div className="popup-modal-header">
                                    <div className='d-flex align-items-start flex-column w-30'>
                                        <div className='d-flex align-items-center w-98'>
                                            <span className='fs-14 w-auto color-F0F0F0 text-truncate' title={hoverdStation?.stationName}>
                                                {hoverdStation?.stationName}
                                            </span>

                                        </div>
                                        <span className='fs-12 color_history text-truncate'>
                                            Ground Station
                                        </span>
                                    </div>
                                    <div className='align-items-center justify-content-center gap-2 w-40 d-flex show__position fs-12'>
                                        <div className="d-flex align-items-center gap-2">
                                            <LatLongSvg />
                                            <span>
                                                {hoverdStation?.properties?.latitude ?
                                                    truncateNumber(hoverdStation?.properties?.latitude, 2) : 'NA'}{'\u00B0'},
                                                {hoverdStation?.properties?.longitude ?
                                                    truncateNumber(hoverdStation?.properties?.longitude, 2) : 'NA'}{'\u00B0'}
                                            </span>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <div className="d-flex align-items-center">
                                                <AltitudeSvg />
                                                <span className="color_history">H</span>
                                            </div>
                                            <span>{hoverdStation?.properties?.altitude ? truncateNumber(hoverdStation?.properties?.altitude, 2) + ' m' : '0m'}</span>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center flex-column w-30'>
                                        <div className='d-flex w-98 flex-column align-items-end justify-content-center'>
                                            <span className='fs-14 color-F0F0F0 text-truncate provider-name' title={hoverdStation?.providerName}>
                                                {hoverdStation?.providerName}
                                            </span>
                                            <span className='fs-12 color_history provider-label'>
                                                Provider
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div className="popup-modal-body">
                                    <div className='w-100 align-items-center flex-column gap-2 pr-4 py-3 show_more_details'>
                                        <div className='d-flex align-items-center justify-content-between w-100'>
                                            <span className='color_history fs-13 w-10 align-items-center justify-content-center d-flex'>Bands</span>
                                            <span className='color_history fs-13 w-20 align-items-center justify-content-center d-flex'>Rx Freq.</span>
                                            <span className='color_history fs-13 w-20 align-items-center justify-content-center d-flex'>Tx Freq.</span>
                                            <span className='color_history fs-13 w-15 align-items-center justify-content-center d-flex'>G/T (dB/K)</span>
                                            <span className='color_history fs-13 w-20 align-items-center justify-content-center d-flex'>EIRP (dBW)</span>
                                            <span className='color_history fs-13 w-15 align-items-center justify-content-center d-flex'>Polarization</span>
                                        </div>
                                        {hoverdStation?.['properties']?.['freqbands']?.map((band: any, index) => {
                                            return (
                                                <div className='d-flex align-items-center justify-content-between w-100' key={index}>
                                                    <span className='color_history align-items-center justify-content-center d-flex fs-12 w-10'>{band?.split('-')?.[0]}</span>
                                                    <span className='fs-12 w-20 align-items-center justify-content-center d-flex color-text'>
                                                        {hoverdStation?.['properties']?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] ? `${hoverdStation?.['properties']?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min']} - ${hoverdStation?.['properties']?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max']}` : '-'}
                                                    </span>
                                                    <span className='fs-12 w-20 align-items-center justify-content-center d-flex color-text'>
                                                        {hoverdStation?.['properties']?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] ? `${hoverdStation?.['properties']?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min']} - ${hoverdStation?.['properties']?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max']}` : '-'}
                                                    </span>
                                                    <span className='fs-12 w-15 align-items-center justify-content-center d-flex color-text'>{hoverdStation?.['properties']?.[`${getBandKey(band, false)}_GT`] ? hoverdStation?.['properties']?.[`${getBandKey(band, false)}_GT`] : '-'}</span>
                                                    <span className='fs-12 w-20 align-items-center justify-content-center d-flex color-text'>{hoverdStation?.['properties']?.[`${getBandKey(band, false)}_EIRP`] ? hoverdStation?.['properties']?.[`${getBandKey(band, false)}_EIRP`] : '-'}</span>
                                                    <span className='fs-12 w-15 align-items-center justify-content-center d-flex color-text' title={hoverdStation?.['properties']?.[`polarization`]}>
                                                        {hoverdStation?.['properties']?.[`polarization`] ?
                                                            hoverdStation?.['properties']?.[`polarization`]?.length > 7 ? hoverdStation?.['properties']?.[`polarization`]?.slice(0, 7) + '...' : hoverdStation?.['properties']?.[`polarization`]
                                                            : '-'
                                                        }
                                                    </span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        }
                    >
                        <div className='popup__modal__details__container'>
                            {stations.map((station, index) => {
                                const providerName = (station?.['properties']?.['provider'] === undefined || station?.['properties']?.['provider'] === "") ? "-" : `${station?.['properties']?.['provider']}`
                                const stationName = station?.['properties']?.['country'] ? `${station?.['groundStationName']}, ${station?.['properties']?.['country']}` : station?.['groundStationName']
                                return (
                                    <div
                                        onMouseEnter={() => setHoverdStation({ ...station, providerName, stationName })}
                                        key={`${stationName}-${index}`}
                                        className='modal__item__container'>
                                        <div className='modal__item__container__header'>
                                            <div className='header__text__icon__container'>
                                                <div className='details__icon__container'>
                                                    <GroundStationSvg />
                                                </div>
                                                <div className='details__text__container'>
                                                    <CustomToolTip title={stationName} placement='left'>
                                                        {stationName}
                                                    </CustomToolTip>
                                                </div>
                                            </div>
                                            <div className='header__other__details__container'>
                                                <div className="d-flex align-items-center gap-2">
                                                    <LatLongSvg />
                                                    <span>{station?.properties?.latitude ? truncateNumber(station?.properties?.latitude, 2) : 'NA'}{'\u00B0'}, {station?.properties?.longitude ? truncateNumber(station?.properties?.longitude, 2) : 'NA'}{'\u00B0'}</span>
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <div className="d-flex align-items-center">
                                                        <AltitudeSvg />
                                                        <span className="color_history">H</span>
                                                    </div>
                                                    <span>{station?.properties?.altitude ? truncateNumber(station?.properties?.altitude, 2) + ' m' : '0m'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </OverlayTrigger>
                }
                {showDevider && <div className='popup__modal__content__seperator' />}
                {targets && targets.length > 0 &&
                    <div className='popup__modal__details__container'>
                        {targets.map((target, index) => {
                            let targetName = target?.name ?? target?.groundTargetName;
                            let targetLong = target?.longitude ?? target?.position?.[0] ?? target?.coordinates?.['long'];
                            let targetLat = target?.latitude ?? target?.position?.[1] ?? target?.coordinates?.['lat'];
                            let target_altitude = target?.altitude ?? target?.position?.[2] ?? target?.coordinates?.['altitude'];
                            return (
                                <div key={`${targetName}-${index}`} className='modal__item__container'
                                    onMouseEnter={() => setHoverdStation(null)}
                                >
                                    <div className='modal__item__container__header'>
                                        <div className='header__text__icon__container gap-1'>
                                            <div className='details__icon__container small'>
                                                <GroundTargetSvg />
                                            </div>
                                            <div className='details__text__container'>
                                                <CustomToolTip title={targetName} placement='left'>
                                                    {targetName}
                                                </CustomToolTip>
                                            </div>
                                        </div>
                                        <div className='header__other__details__container'>
                                            <div className="d-flex align-items-center gap-2 ">
                                                <LatLongSvg />
                                                <span>{!targetLat ? 'NA' : truncateNumber(targetLat, 2)}{'\u00B0'}, {!targetLong ? 'NA' : truncateNumber(targetLong, 2)}{'\u00B0'}</span>
                                            </div>
                                            <div className="d-flex gap-1">
                                                <div className="d-flex align-items-center">
                                                    <NewAltitudeSvg />
                                                </div>
                                                <span>{!target_altitude ? 'NA' : truncateAltitude(target_altitude) + ' km'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                }

            </div >
        )

    }
    return null
}

export default MultiGroundObjectCard